import React, { useEffect } from "react"
import PropTypes from "prop-types"
import moment from "moment"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

import "./payment_info_form.scss"

export default function Success({
  continuePath,
  email,
  svgUrl,
  interval,
  formattedPrice,
  showSuccessFollowingRateLimit,
  subscriptionMobileSuccessPath,
  subscriptionPlan,
  subscriptionStartedAt,
  trialEnd,
}) {
  const afterPaymentPath = sessionStorage.getItem("afterProPaymentPath")
  const continueDestination =
    subscriptionMobileSuccessPath || afterPaymentPath || continuePath

  function handleContinueClick(e) {
    e.stopPropagation()
    e.preventDefault()

    sessionStorage.removeItem("afterProPaymentPath")
    window.Turbolinks.visit(continueDestination)
  }

  useEffect(() => {
    logIFTTTNextAction("page_viewed", {
      location_type:
        subscriptionPlan === "intermediate_pro"
          ? "intermediate_pro_checkout_success"
          : "pro_checkout_success",
      object_status: "upgraded_to_pro",
    })
  }, [])

  // Remove timezone parsing and use Stripe oficial timezone (user account)
  const receiptDate = moment.utc(new Date(subscriptionStartedAt))

  const isTrial = !!trialEnd
  const trialEnds = moment.unix(trialEnd).format("LL")
  const headerCopy = isTrial
    ? `Your first billing period begins after your free trial ends on ${trialEnds}`
    : `Receipt for ${receiptDate.format("LL")}`

  let renewalCopy
  if (!isTrial) {
    if (interval === "month") {
      renewalCopy = `Renews on the ${receiptDate.format("Do")} of each month`
    } else if (interval === "year") {
      renewalCopy = `Renews yearly on ${receiptDate.format("MMMM Do")}`
    }
  }

  let successCopy
  if (subscriptionPlan === "pro") {
    successCopy = `You have access to IFTTT Pro+, which includes unlimited Applets, and some seriously powerful tools, like queries and filter code.`
  } else if (subscriptionPlan === "intermediate_pro") {
    successCopy =
      "You have access to IFTTT Pro, which includes 20 Applets, faster runtimes, multi-action Applets, and customer support."
  }

  return (
    <div className="width-sm" styleName="payment-info-form payment-success">
      <div className="payment-sucess-container">
        <section styleName="success-message">
          <h1 className="mt0 mb3">Success!</h1>
          <p>{successCopy}</p>
        </section>

        <section styleName="receipt-container" className="mt4">
          <section
            className="right-panel"
            title="Success!"
            alt="Person holding a trophy"
            styleName="success-illustration"
          >
            <img src={svgUrl} alt="Person holding a trophy" />
          </section>
          <div styleName="receipt-details-container" className="ml3">
            {showSuccessFollowingRateLimit === false && (
              <>
                <h3 className="txt-body-3">{headerCopy}</h3>
                <div styleName="receipt-body" className="mt3">
                  <section>
                    <h6 className="mt0">Amount</h6>
                    <p className="txt-body-3">
                      {formattedPrice}/{interval}
                      {renewalCopy && <small>{renewalCopy}</small>}
                    </p>
                  </section>
                  <section styleName="receipt-user-detail">
                    <h6 className="mt0">Email</h6>
                    <p className="txt-body-3">{email}</p>
                  </section>
                </div>
              </>
            )}
            <div styleName="continue" className="mt3">
              <button
                type="submit"
                className="button-secondary full-width"
                title="Continue to create"
                aria-label="Continue to create"
                href={continueDestination}
                onClick={handleContinueClick}
              >
                Get started
              </button>
            </div>
          </div>
        </section>
      </div>
      <br />
    </div>
  )
}

Success.propTypes = {
  onboardingPath: PropTypes.string,
  continuePath: PropTypes.string.isRequired,
  svgUrl: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  formattedPrice: PropTypes.string.isRequired,
  interval: PropTypes.oneOf(["month", "year"]).isRequired,
  subscriptionStartedAt: PropTypes.string.isRequired,
  subscriptionMobileSuccessPath: PropTypes.string,
  showSuccessFollowingRateLimit: PropTypes.bool,
  trialEnd: PropTypes.number,
  subscriptionPlan: PropTypes.oneOf(["legacy_pro", "intermediate_pro", "pro"]),
}
